const FETCH_PEOPLE_REQUEST = "FETCH_PEOPLE_REQUEST";
const FETCH_PEOPLE_SUCCESS = "FETCH_PEOPLE_SUCCESS";
const FETCH_PEOPLE_FAILURE = "FETCH_PEOPLE_FAILURE";

export default {
  FETCH_PEOPLE_REQUEST,
  FETCH_PEOPLE_SUCCESS,
  FETCH_PEOPLE_FAILURE,
};
